module.exports = __webpack_public_path__ + "static/media/intro.2d46ebf3.mp3";